var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBookmark = function SvgBookmark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1b1f",
    d: "M7.013 15.548a1.5 1.5 0 0 1-2.091-1.378V4.772q0-.593.41-1.002t1.002-.41h3.905c.657 0 .856.892.261 1.171H6.334a.23.23 0 0 0-.165.075.23.23 0 0 0-.075.166v9.876L10 12.968l3.906 1.68V9.805a.586.586 0 0 1 1.172 0v4.653a1.31 1.31 0 0 1-1.826 1.204L10 14.267zm7.48-7.892a.586.586 0 0 1-.587-.586v-.976h-.976a.586.586 0 0 1 0-1.172h.976v-.977a.586.586 0 0 1 1.172 0v.977h.977a.586.586 0 0 1 0 1.172h-.977v.976a.586.586 0 0 1-.586.586"
  })));
};
export default SvgBookmark;